import { secureApiPost } from '../secureHttp';

export type BlockageCreateInput = {
  date: string; // Format: YYYY-MM-DD
  start_time: string; // Format: HH:MM (24-hour format)
  end_time: string; // Format: HH:MM (24-hour format)
  reason?: string; // Optional reason for blocking the time
};

export type BlockageCreateResponse = {
  message?: string;
  blockages?: Array<{
    id: string;
    date: string;
    start_time: string;
    end_time: string;
    reason?: string;
  }>;
};

/**
 * Create blockage slots for a psychologist's calendar
 * This will create blockage slots every 30 minutes between start_time and end_time
 *
 * @param data - Blockage creation input (dates/times are in UTC)
 * @returns Response with created blockages
 */
export async function createBlockage(data: BlockageCreateInput): Promise<BlockageCreateResponse> {
  return await secureApiPost<BlockageCreateResponse, BlockageCreateInput>(
    `/v1/psi-platform/psychologist/calendar/blockages`,
    data,
    {
      showSuccessToast: false, // No mostrar toast automático, se muestra desde BlockScheduleModal
      errorMessage: 'Error al bloquear horario',
    }
  );
}
